module.exports = __webpack_public_path__ + "img/28_25.ec82aec7.png";